var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckBoxChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 2.5H3.75C3.05859 2.5 2.5 3.05859 2.5 3.75V16.25C2.5 16.9414 3.05859 17.5 3.75 17.5H16.25C16.9414 17.5 17.5 16.9414 17.5 16.25V3.75C17.5 3.05859 16.9414 2.5 16.25 2.5ZM14.1992 7.75391L8.97656 13H8.97266C8.90625 13.0664 8.72656 13.2148 8.51953 13.2148C8.37109 13.2148 8.20312 13.1328 8.0625 12.9922L5.875 10.8047C5.8125 10.7422 5.8125 10.6445 5.875 10.582L6.57031 9.88672C6.60156 9.85547 6.64062 9.83984 6.67969 9.83984C6.71875 9.83984 6.75781 9.85547 6.78906 9.88672L8.52344 11.6211L13.2891 6.82031C13.3203 6.78906 13.3594 6.77344 13.3984 6.77344C13.4414 6.77344 13.4805 6.78906 13.5078 6.82031L14.1914 7.52734C14.2617 7.59375 14.2617 7.69141 14.1992 7.75391Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxChecked);
export default __webpack_public_path__ + "static/media/CheckBoxChecked.78028b6b.svg";
export { ForwardRef as ReactComponent };